module.exports = __webpack_public_path__ + "9f7209a9f23b11a519e82ddc78607e22.svg";